/**
 * @desc 包裹重推
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.ResubmitPackageRpcDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/systemOrderPackage/resubmit`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
